import CanvasLabelLinker from "./output-labels-dom/canvas-label-linker.js";

import LabelCreator from "./output-labels-dom/labels/label-creator.js";
import LabelVisibilityController from "./output-labels-dom/labels/label-visibility-controller.js";
import LabelPositionController from "./output-labels-dom/labels/label-position-controller.js";
import LabelContentController from "./output-labels-dom/labels/label-content-controller.js";

class OutputLabelsDom {
    constructor({ domElement }) {
        const canvasLabelLinker = new CanvasLabelLinker(domElement);

        const labelControllers = {
            creator: new LabelCreator(),

            properties: {
                visibilityController: new LabelVisibilityController(),
                positionController: new LabelPositionController(),
                contentController: new LabelContentController(),
            },
        };

        this._params = {
            canvasLabelLinker,
            labelControllers,
        };
    }

    get params() {
        return this._params;
    }
}

export default OutputLabelsDom;
